import { FormControlProps } from "react-bootstrap/FormControl";

import { useWindowDimensions } from "@/hooks/useWindowDimensions";

import { FormattedFormControl } from "@/components/FormControl/FormattedFormControl/index";
import { SkeletonWrapper } from "@/components/SkeletonWrapper";

type Props = FormControlProps & {
	skeleton?: boolean;
};

export function HeartRate({ skeleton, ...rest }: Props) {
	const { width } = useWindowDimensions();

	return (
		<>
			{skeleton ? (
				<SkeletonWrapper />
			) : (
				<FormattedFormControl
					formattedFormControlClassName="form-control-solid"
					label={`Frequência Cardíaca ${(width > 444 && "(BPM)") || ""}`}
					mask="000"
					isMaskedInput
					id={rest.id}
					{...(rest as any)}
				/>
			)}
		</>
	);
}
